import { routeInfo } from './../../../../routeInfo';
import React from 'react';
import HistoryKeeper from '../../../../services/HistoryKeeper';
import history from '../../../../history';
import errorMessages from '../../../../const/errorMessages';
import errorCodes from '../../../../const/errorCodes';
import ValidationForm from '../../../forms/ValidationForm';
import LoginBackButton from '../LoginBackButton/LoginBackButton';

class RestorePasswordForm extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            checkRestorePswdInProcess: true
        };
    }

    goBack = () => {
        var prevLocation = HistoryKeeper.getPrevLocation();
        if (prevLocation) {
            history.push(prevLocation.path);
        } else {
            history.push(routeInfo.login.url());
        }
    }

    componentDidMount() {
        const { checkIfRestorePasswordAvailable, email, hex } = this.props;
        checkIfRestorePasswordAvailable({ hex, email }).then(this.updateCheckPswdState, () => { });
    }

    updateCheckPswdState = () => {
        this.setState({ checkRestorePswdInProcess: false });
    }

    validatePassword({ password }) {
        if (!password) {
            return 'Enter your password';
        }
        if (password && password.length < 8) {
            return errorMessages[errorCodes.passwordTooShort];
        }
        return null;
    }

    validateConfirmPassword({ password, confirmedPassword }) {
        if (!confirmedPassword) {
            return 'Confirm your password';
        }
        if (password !== confirmedPassword) {
            return "Your passwords don't match";
        }
        return null;
    }

    ok = ({ password }) => {
        const { hex, email, restorePassword } = this.props;
        restorePassword({ email, password, hex });
    }

    render() {
        const { email } = this.props;
        const { checkRestorePswdInProcess } = this.state;
        return (
            <div className="restore-password-form">
                <div className="restore-password-form_header">
                    <LoginBackButton goBack={this.goBack} />
                   Recover your password
                </div>

                <ValidationForm
                    enableActionBtnByDefault={true}
                    enableActionBtnAlways={true}
                    inputs={[
                        {
                            label: "Email",
                            name: "email",
                            value: email,
                            disabled: true
                        },
                        {
                            label: "Password",
                            name: "password",
                            type: "password",
                            applyOnEnter: true,
                            disabled: checkRestorePswdInProcess,
                            rules: [this.validatePassword]
                        },
                        {
                            label: "Confirm Password",
                            name: "confirmedPassword",
                            type: "password",
                            applyOnEnter: true,
                            disabled: checkRestorePswdInProcess,
                            rules: [this.validateConfirmPassword]
                        }
                    ]}
                    buttons={[{
                        key: 'ok',
                        label: 'Change Password & Sign In',
                        action: this.ok,
                        className: `restore-password-form_btn ${checkRestorePswdInProcess && 'btn-loader'}`
                    }]}
                />
            </div>
        );
    }
}

export default RestorePasswordForm;